// Packages
import { notification } from 'antd';
import { ArgsProps, NotificationPlacement } from 'antd/lib/notification/interface';
// Helpers
import { getNotificationIcon } from './notificationIcons';

type IconType = 'success' | 'info' | 'error' | 'warning';

type TNotification = (
  type: IconType,
  message: React.ReactNode,
  description?: React.ReactNode,
  placement?: NotificationPlacement,
  duration?: number,
) => void;

// antd types `props` (spread on the notice root) as an HTML bag that names `data-testid` only; the app's
// attribute is `data-cy`. `data-type` says which kind it is, so a test does not read a class.
const getNoticeProps = (type: IconType) =>
  ({ 'data-cy': 'toast', 'data-type': type } as ArgsProps['props']);

const showNotification: TNotification = (
  type,
  message,
  description,
  placement = 'topRight',
  duration = 5,
) => {
  notification[type as IconType]({
    title: message,
    // rc-notification renders a description for any non-null value, so '' still added an empty row
    // under an 8px gap and pushed a title-only toast's text above the middle. Callers pass '' to skip it.
    description: description || undefined,
    placement,
    duration,
    icon: getNotificationIcon(type),
    props: getNoticeProps(type),
  });
};

export default showNotification;
